import { Injectable } from "@angular/core";
import { Invite } from "../../models/invite-model";
import { InviteCreation } from "../../models/inviteCreationModel";
import { ApiService } from "./api.base.service";
import { SignContent } from "../../models/sign-content";
import { InviteGrid, PagedInviteGridDto } from "../../models/invite-grid-model";
import { BlockUnblockRequestModel } from "../../models/block-unblock-request-model";
import { IWService } from "../iw.service";
import { GetContent, SignatureResponse } from "../../models/get-content";
import { SDKOperationRequest } from "@extrimian/identity-wallet";
import { ReturnStatement } from "@angular/compiler";
import { NewUserDocumentProcessTo } from "../../models/newUserDocumentProcessTo-model";
import { InviteSearchResult } from "../../models/invite-search-result";
import { PagedList } from "../../models/pagination";
import { IncomingChatMessageStatusEnum, OutgoingChatMessageStatusEnum } from "../../models/enums/IncomingChatMessageStatusEnum";

@Injectable({ providedIn: "root" })
export class InviteService {
  baseUrl = "api/invite";

  constructor(private apiService: ApiService, private iwService: IWService) { }



  async getUsers(page?: number, itemsPerPage?: number, id?:number, isUsersGrid?: boolean): Promise<PagedInviteGridDto> {
    return await this.apiService.get<PagedInviteGridDto>(
      `${this.baseUrl}/users/${page}/${itemsPerPage}/${id}/${isUsersGrid}`
    );
  }
  async getPatients(page?: number, itemsPerPage?: number): Promise<PagedInviteGridDto> {
    return await this.apiService.get<PagedInviteGridDto>(
      `${this.baseUrl}/patients/${page}/${itemsPerPage}`
    );
  }

  async getOrganizationInvites(page?: number, itemsPerPage?: number): Promise<PagedInviteGridDto> {
    return await this.apiService.get<PagedInviteGridDto>(
      `${this.baseUrl}/organizationinvites/${page}/${itemsPerPage}`
    );
  }

  public async addNewInvite(invite: InviteCreation): Promise<InviteCreation> {
    let inviteResponse = await this.apiService.post<InviteCreation>(
      `${this.baseUrl}/add-new-invite`,
      invite
    );

    return inviteResponse;
  }

  async delete(inviteId: number): Promise<void> {
    return await this.apiService.delete(
      `${this.baseUrl}/delete-invite-by-id/${inviteId}`
    );
  }

  public async get(inviteId: number): Promise<InviteCreation> {
    return await this.apiService.get<InviteCreation>(
      `${this.baseUrl}/${inviteId}`
    );
  }

  public async existUserByOrganization(systemAccountSintraId: string, organizationCode: string): Promise<InviteCreation> {
    return await this.apiService.get<InviteCreation>(
      `${this.baseUrl}/existuserbyorganization/${systemAccountSintraId}/${organizationCode}`
    );
  }
  
  public async isAnyNotificationSignatureInProgress(
    inviteIds: string
  ): Promise<boolean> {
    return await this.apiService.get<boolean>(
      `${this.baseUrl}/isanynotificationsignatureinprogress/${inviteIds}`
    );
  }

  public async isAnyBlockUnblockSignatureInProgress(
    inviteId: Number
  ): Promise<boolean> {
    return await this.apiService.get<boolean>(
      `${this.baseUrl}/isanyblockunblocksignatureinprogress/${inviteId}`
    );
  }

  public async getInviteDetails(inviteId: Number): Promise<Invite> {
    return await this.apiService.get<Invite>(
      `${this.baseUrl}/getinvitedetails/${inviteId}`
    );
  }

  public async getInvitesListDetails(inviteId: string): Promise<Invite[]> {
    return await this.apiService.get<Invite[]>(
      `${this.baseUrl}/getinviteslistdetails/${inviteId}`
    );
  }

  public async inviteValidator(newUserDocumentProcessTo: NewUserDocumentProcessTo):Promise<void> {

    return await this.apiService.post<void>(
      `${this.baseUrl}/getInviteValidator`,
      newUserDocumentProcessTo
    );

  }

  public async updateNewInvite(invite: InviteCreation): Promise<InviteCreation> {
    let inviteResponse = await this.apiService.post<InviteCreation>(
      `${this.baseUrl}/update-new-invite`,
      invite
    );

    return inviteResponse;
  }

  public async searchUsers(term: string, page: number = 1, pageSize: number = 10): Promise<PagedList<InviteSearchResult>> {
    const body: any = { pageNumber: page, pageSize };
    if (term) body.term = term;
    return await this.apiService.post<PagedList<InviteSearchResult>>(
      `${this.baseUrl}/search`,
      body
    );
  }

  public async resendInvitation(inviteId: number): Promise<void> {
    return await this.apiService.post<void>(
      `${this.baseUrl}/${inviteId}/resend`,
      null
    );
  }

  public async changeUserRole(userInvite: Invite): Promise<Invite>{
    var response = await this.apiService.post<Invite>(
        `${this.baseUrl}/changeUserRole`,
        userInvite
    );

    return response;
}

public async changeUserRoleAmi(userInvite: Invite){

  var message = '';
  if(userInvite.role == 'Admin')
  {
    message = 'El rol del usuario ' + userInvite.fullName + ' se está cambiando a Operador. ¿Deseas confirmar esta acción?';
  }
  else
  {
    message = 'El rol del usuario ' + userInvite.fullName + ' se está cambiando a Administrador. Deseas confirmar esta acción?';
  }
  var response = await this.apiService.post<string>(
      `api/blockunblock/sendNotificationAmiText`,
      { message }
  );

  var statusResponse: OutgoingChatMessageStatusEnum= this.getEnumNameByValue(response);
  return statusResponse;

}

getEnumNameByValue(value: string): OutgoingChatMessageStatusEnum {
  const intValue = parseInt(value);
  switch (intValue) {
    case OutgoingChatMessageStatusEnum.CONFIRMED:
      return OutgoingChatMessageStatusEnum.CONFIRMED;
    case OutgoingChatMessageStatusEnum.ERROR:
      return OutgoingChatMessageStatusEnum.ERROR;
    default:
      throw new Error('Valor de respuesta no válido');
  }
}
}

